/////////////////////////////////////////////////////////////////////////////////////////////
// Copyright 2026 Garmin International, Inc.
// Licensed under the Flexible and Interoperable Data Transfer (FIT) Protocol License; you
// may not use this file except in compliance with the Flexible and Interoperable Data
// Transfer (FIT) Protocol License.
/////////////////////////////////////////////////////////////////////////////////////////////
// ****WARNING****  This file is auto-generated!  Do NOT edit this file.
// Profile Version = 21.218.0Release
// Tag = production/release/21.218.0-0-g96fee6d7
/////////////////////////////////////////////////////////////////////////////////////////////

package com.garmin.fit

import com.garmin.fit.types.*
import kotlin.time.Instant

/**
 * The FIT `aad_accel_features` message.
 *
 * Number of acclerometer zero crossings summed over the specified time interval
 *
 * A thin typed view over [Mesg]: the accessors below read and write the same
 * numbered fields the untyped API exposes, so nothing is hidden by using them.
 */
public open class AadAccelFeaturesMesg : Mesg {
    public constructor() : super("AadAccelFeatures", Profile.MesgNum.AAD_ACCEL_FEATURES)

    public constructor(mesg: Mesg) : super(mesg)

    internal constructor(mesg: Mesg, adopt: Boolean) : super(mesg, adopt)

    /** timestamp. */
    public var timestamp: Instant?
        get() = (getFieldValue(TIMESTAMP_FIELD_NUM) as? UInt)?.let { FitDateTime.toInstant(it) }
        set(value) = setFieldValue(TIMESTAMP_FIELD_NUM, value?.let { FitDateTime.toTimestamp(it) })

    /** time, in s. Time interval length in seconds */
    public var time: UShort?
        get() = getFieldValue(TIME_FIELD_NUM) as? UShort
        set(value) = setFieldValue(TIME_FIELD_NUM, value)

    /** energy_total. Total accelerometer energy in the interval */
    public var energyTotal: UInt?
        get() = getFieldValue(ENERGY_TOTAL_FIELD_NUM) as? UInt
        set(value) = setFieldValue(ENERGY_TOTAL_FIELD_NUM, value)

    /** zero_cross_cnt. Count of zero crossings */
    public var zeroCrossCnt: UShort?
        get() = getFieldValue(ZERO_CROSS_CNT_FIELD_NUM) as? UShort
        set(value) = setFieldValue(ZERO_CROSS_CNT_FIELD_NUM, value)

    /** instance. Instance ID of zero crossing algorithm */
    public var instance: UByte?
        get() = getFieldValue(INSTANCE_FIELD_NUM) as? UByte
        set(value) = setFieldValue(INSTANCE_FIELD_NUM, value)

    /** time_above_threshold, in s. Total accelerometer time above threshold in the interval */
    public var timeAboveThreshold: Double?
        get() = getFieldValue(TIME_ABOVE_THRESHOLD_FIELD_NUM) as? Double
        set(value) = setFieldValue(TIME_ABOVE_THRESHOLD_FIELD_NUM, value)

    public companion object {
        public const val TIMESTAMP_FIELD_NUM: UByte = 253u
        public const val TIME_FIELD_NUM: UByte = 0u
        public const val ENERGY_TOTAL_FIELD_NUM: UByte = 1u
        public const val ZERO_CROSS_CNT_FIELD_NUM: UByte = 2u
        public const val INSTANCE_FIELD_NUM: UByte = 3u
        public const val TIME_ABOVE_THRESHOLD_FIELD_NUM: UByte = 4u

        /**
         * The profile definition of every field of this message, with no values.
         *
         * Built once when this class is first touched, and handed out only as
         * copies, so the decoder pays for a message type it never meets nothing.
         */
        internal val PROTOTYPE_FIELDS: Map<Int, Field> = buildPrototypeFields()

        private fun buildPrototypeFields(): Map<Int, Field> {
            val fields = LinkedHashMap<Int, Field>()
            fields[253] = Field("Timestamp", 253u, BaseType.UINT32, 1.0, 0.0, "", false)
            fields[0] = Field("Time", 0u, BaseType.UINT16, 1.0, 0.0, "s", false)
            fields[1] = Field("EnergyTotal", 1u, BaseType.UINT32, 1.0, 0.0, "", false)
            fields[2] = Field("ZeroCrossCnt", 2u, BaseType.UINT16, 1.0, 0.0, "", false)
            fields[3] = Field("Instance", 3u, BaseType.UINT8, 1.0, 0.0, "", false)
            fields[4] = Field("TimeAboveThreshold", 4u, BaseType.UINT16, 25.0, 0.0, "s", false)
            return fields
        }
    }
}
